import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { NbAuthService } from '@nebular/auth';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { RoleProvider } from '../../auth/role.provider';

@Injectable()
export class InstructorGuard implements CanActivate {
  constructor(
    private authService: NbAuthService,
    private router: Router,
    private roleProvider: RoleProvider
  ) {}

  canActivate(): Observable<boolean> {
    return this.roleProvider.isAtLeastInstructor().pipe(
      tap((isInstructor) => {
        if (!isInstructor) {
          this.router.navigate(['dashboard']);
        }
      })
    );
  }
}
